import { Syringe, Sparkles, Dumbbell, Wand2 } from "lucide-react";

// Tratamiento visual por categoria cuando el servicio no tiene foto propia
// (evita repetir la misma imagen generica en 18 de 19 tarjetas): un tinte de
// marca + icono + tipografia, en vez de una foto de banco repetida.
// Fix A (2026-09-04): tintes derivados de la paleta de marca (Champagne,
// Marfil y Taupe al 30%) en vez de los marrones anteriores.
const CATEGORY_STYLES = {
  "Inyectables": { bg: "#EFE3D2", icon: Syringe },
  "Faciales y piel": { bg: "#F2EDE4", icon: Sparkles },
  "Contorno corporal": { bg: "#E6DDD2", icon: Dumbbell },
};
const DEFAULT_STYLE = { bg: "#F7F3ED", icon: Wand2 };

export default function CategoryPlaceholder({ category, name }) {
  const { bg, icon: Icon } = CATEGORY_STYLES[category] || DEFAULT_STYLE;
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-4 px-4 text-center" style={{ backgroundColor: bg }}>
      <Icon className="w-8 h-8 text-[var(--brand-primary)]" strokeWidth={1.5} />
      <span className="font-serif text-lg leading-snug text-[#292522]">{name}</span>
    </div>
  );
}
